export const gpColors = {
    logoBrown: '#B20502',
    logoGray: '#36404b',
    editButton: '#3792cb'
}
